import { loadScript } from "./loadScript"

var MyMixin = {
    methods: {
        loadComponentScript: function( componentName ) {
            loadScript(`${this.$root.site_url}/wp-content/themes/wpvue/elements/${componentName}/${componentName}.min.js`)
              .then(() => {})
              .catch(() => console.log(`${componentName} script load error!!`))
        },
        checkImageAsset: function (assets) {
            if (assets) {
                return true
            } else {
                throw new Error('Product assets missing')
            }
        },
        getBPMGlobalString: function (num, text, name) {
            let globalString1 = text.replace("%numbercasino", num === null ? 0 : num)
            let globalString2 = globalString1.replace("%casino_casinos", (num > 1) ? this.$root.i18n.casinos : this.$root.i18n.casino)
            let globalString3 = globalString2.replace("%payment", name)
            return globalString3
        },
        getPLGlobalString: function (num, text, name) {
            let globalString1 = text.replace("%numbercasino", num === null ? 0 : num)
            let globalString2 = globalString1.replace("%casino_casinos", (num > 1) ? this.$root.i18n.casinos : this.$root.i18n.casino)
            let globalString3 = globalString2.replace("%software", name)
            return globalString3
        },
        getPaymentGlobalString: function (text, payment) {
            let globalString = text.replace("%payment", payment)
            return globalString
        },
        getPartnerGlobalString: function (text, partner) {
            let globalString = text.replace("%partner", partner)
            return globalString
        },
        checkPlayFreeButton: function () {
            let countryCode = this.$cookies.get("wp-country")
            if (this.$root.free_games_global_countries != '') {
                if (this.$root.free_games_global_countries.includes(countryCode)) {
                    return false
                } else {
                    return true
                }
            } else {
                return true
            }
        },
        validPromotionCountryCode: function (data) {
            let countryCode = this.$cookies.get("wp-country")
            if (data && data.country_code && data.country_code != '') {
                if (data.country_code.includes(countryCode)) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        },
        getCASToplistShowHideData: function (partner) {
            let hideBonus = (partner.hasOwnProperty('show_bonus') && partner.show_bonus === '1') ? "0" : "1"
            let hideToplist = (partner.hasOwnProperty('hide_toplist')) ? partner.hide_toplist : "0"
            if (partner.banned_time_from != null && partner.banned_time_to != null) {
                let current_time = new Date() //Current Time
                // Start Time
                let startTime = partner.banned_time_from
                let banned_time_from = new Date(current_time.getTime())
                banned_time_from.setHours(startTime.split(":")[0])
                banned_time_from.setMinutes(startTime.split(":")[1])
                banned_time_from.setSeconds(startTime.split(":")[2])
                //End Time
                let endTime = partner.banned_time_to
                let banned_time_to = new Date(current_time.getTime())
                banned_time_to.setHours(endTime.split(":")[0])
                banned_time_to.setMinutes(endTime.split(":")[1])
                banned_time_to.setSeconds(endTime.split(":")[2])

                //if (banned_time_from > banned_time_to) (new Date(partner.banned_time_from).setDate
                //(new Date(partner.banned_time_from).getDate() + 1))
                if (banned_time_from <= current_time && current_time <= banned_time_to) {
                    // Hide Bonus and modify variablesbanned_time_from <= (new Date().setDate
                    //(new Date().getDate() + 1)) &&
                    hideBonus = partner.hide_bonus
                    hideToplist = partner.hide_toplist
                }
            }

            return { 'hide_bonus': hideBonus, 'hide_toplist': hideToplist }
        },
        getCASDataImage: function (assetdata, size) {
            return assetdata.filter((ele) => ele.asset_category_name === size
            ).length > 0 ? true : false
        },
        getAltText: function (altText, url) {
            let textAlt = ''
            if (altText && altText != '') {
                textAlt = altText
            } else {
                if (url)
                    textAlt = url.substring(url.lastIndexOf('/') + 1).split('.')[0]
            }
            return textAlt
        },
        getProviderLink: function (provider_link, slug) {
            const expression = /(http(s)?:\/\/.)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
            const regex = new RegExp(expression)
            if (provider_link) {
                if (provider_link.match(regex)) {
                    return provider_link
                } else {
                    return `https://${provider_link}`
                }
            } else {
                throw new Error('Provider Link missing')
            }
        },
        getGoLink: function (go_link, slug) {
            const expression = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
            const regex = new RegExp(expression)
            if (go_link) {
                if (go_link.match(regex)) {
                    return go_link
                } else {
                    return `${this.$root.site_url}/${go_link}/${slug}`
                }
            } else {
                throw new Error('Goto Link missing')
            }
        },
        getRouteLink(slug, type, base = '') {
            const post_types = Object.values(wpvue_script_data_params.data.post_types)
            if (slug === 'home') {
                return `/`
            } else {
                if (post_types.indexOf(type) > -1)
                    return (base) ? `/${base}/${slug}` : `/${type}/${slug ? slug.replace('/', '') : ''}`
                else
                    return (base) ? `/${base}/${slug}` : `/${slug ? slug.replace('/', '') : ''}`
            }
        },
        hasCoreBlock(block) {
            const vue_blocks = Object.values(wpvue_script_data_params.data.vue_blocks)
            if (!(vue_blocks.indexOf(block) > -1))
                return true
            else
                return false
        },
        hasTag(tags) {
            if (tags) {
                let wpTags = wpvue_script_data_params.data.site_data.cas_data.tags_label
                if (wpTags && wpTags.length > 0) {
                    let casTags = tags.split(',')
                    let tagObject = {}
                    for (var i = 0;i < wpTags.length;i++) {
                        let count = 0
                        for (var j = 0;j < casTags.length;j++) {
                            if (wpTags[i].tag_name.toLowerCase() === casTags[j].toLowerCase() && count === 0) {
                                tagObject = wpTags[i]
                                count++
                                break
                            }
                        }
                        if (count === 1) {
                            break
                        }
                    }
                    return tagObject
                } else {
                    return []
                }
            } else {
                return []
            }
        },
        utf8Decode: function (utf8String) {
            if (typeof utf8String != 'string') throw new TypeError('parameter ‘utf8String’ is not a string')
            // note: decode 3-byte chars first as decoded 2-byte strings could appear to be 3-byte char!
            const unicodeString = utf8String.replace(
                /[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g,  // 3-byte chars
                function (c) {  // (note parentheses for precedence)
                    var cc = ((c.charCodeAt(0) & 0x0f) << 12) | ((c.charCodeAt(1) & 0x3f) << 6) | (c.charCodeAt(2) & 0x3f)
                    return String.fromCharCode(cc)
                }
            ).replace(
                /[\u00c0-\u00df][\u0080-\u00bf]/g,                 // 2-byte chars
                function (c) {  // (note parentheses for precedence)
                    var cc = (c.charCodeAt(0) & 0x1f) << 6 | c.charCodeAt(1) & 0x3f
                    return String.fromCharCode(cc)
                }
            )
            return unicodeString
        },
        youtubeInit: function () {
            let recaptchaScript = document.createElement('script')
            recaptchaScript.setAttribute('src', this.$root.youtube_script_path)
            document.head.appendChild(recaptchaScript)
        },
        fbInit: function () {
            window.fbAsyncInit = (function (d, s, id) {
                var js,
                    fjs = d.getElementsByTagName(s)[0]
                if (d.getElementById(id)) {
                    return
                }
                js = d.createElement(s)
                js.id = id
                js.src = "//connect.facebook.net/en_US/sdk.js"
                fjs.parentNode.insertBefore(js, fjs)
            })(document, "script", "facebook-jssdk")
        },
        twitterInit: function () {
            window.twttr = (function (d, s, id) {
                var t, js, fjs = d.getElementsByTagName(s)[0]
                if (d.getElementById(id)) return; js = d.createElement(s); js.id = id
                js.src = "https://platform.twitter.com/widgets.js"; fjs.parentNode.insertBefore(js, fjs)
                return window.twttr || (t = { _e: [], ready: function (f) { t._e.push(f) } })
            }(document, "script", "twitter-wjs"))
        },
        instagramInit: function () {
            window.instagram = (function (d, s, id) {
                var js,
                    fjs = d.getElementsByTagName(s)[0]

                if (!d.getElementById(id)) {
                    js = d.createElement(s)
                    js.setAttribute("onLoad", "window.instgrm.Embeds.process()")
                    js.id = id
                    js.src = "https://platform.instagram.com/en_US/embeds.js"

                    fjs.parentNode.insertBefore(js, fjs)
                }
            }(document, "script", "instagram-wjs"))
        },
        tumblrInit: function () {
            window.tumblr = (function (d, s, id) {
                var js,
                    fjs = d.getElementsByTagName(s)[0]
                if (d.getElementById(id)) {
                    return
                }
                js = d.createElement(s)
                js.id = id
                js.src = "https://assets.tumblr.com/post.js"
                fjs.parentNode.insertBefore(js, fjs)
            })(document, "script", "tumblr-wjs")
        },
        tiktokInit: function () {
            window.tiktok = (function (d, s, id) {
                var js,
                    fjs = d.getElementsByTagName(s)[0]
                if (d.getElementById(id)) {
                    return
                }
                js = d.createElement(s)
                js.id = id
                js.src = "https://www.tiktok.com/embed.js"
                fjs.parentNode.insertBefore(js, fjs)
            })(document, "script", "tiktok-wjs")
        },
        titleCase: function (str) {
            var splitStr = str.toLowerCase().split(' ')
            for (var i = 0;i < splitStr.length;i++) {
                // You do not need to check if i is larger than splitStr length, as your for does that for you
                // Assign it back to the array
                splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
            }
            // Directly return the joined string
            return splitStr.join(' ')
        }
    }
}

export default MyMixin


// WEBPACK FOOTER //
// ./src/misc/constant.js